import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col lg:flex-row lg:items-baseline w-full lg:justify-between md:px-2 mt-[18px] md:mt-0" }
const _hoisted_2 = {
  class: "relative",
  "pt:root:class": "m-5 bg-emerald-500"
}
const _hoisted_3 = { class: "md:px-2 lg:flex lg:justify-between lg:items-baseline" }
const _hoisted_4 = { class: "font-bold text-[20px] my-2" }
const _hoisted_5 = {
  key: 0,
  class: "text-[20px] leading-[28.5px]"
}
const _hoisted_6 = {
  key: 1,
  class: "text-[20px] leading-[28.5px]"
}
const _hoisted_7 = {
  key: 2,
  class: "text-[20px] leading-[28.5px]"
}
const _hoisted_8 = {
  key: 3,
  class: "text-[20px] leading-[28.5px]"
}
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = { class: "font-bold text-gray-500" }
const _hoisted_12 = { class: "relative p-1 font-bold hover:border-1" }
const _hoisted_13 = { class: "w-full text-h-primary-500" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "!p-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSearchSubmit && _ctx.onSearchSubmit(...args)), ["prevent"])),
        class: "mb-2 lg:w-[429px] h-[36px]"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_icon, {
            name: "hi-search",
            class: "pi pi-search !absolute !left-4 !top-[50%] translate-y-[-50%] w-[20px] h-[20px] text-gray-400"
          }),
          _createVNode(_component_InputText, {
            placeholder: _ctx.$t('labels.generic', {
        pt: 'Pesquisar por Título ou Capítulo',
        en: 'Search by Title or Chapter',
      })
        ,
            modelValue: _ctx.searchInputText,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchInputText) = $event)),
            class: "!h-[36px] !pl-10 !p-[8px] !shadow-yellow-300"
          }, null, 8, ["placeholder", "modelValue"])
        ])
      ], 32),
      _createVNode(_component_RouterLink, {
        to: `/${_ctx.courseName}/${_ctx.courseId}/forum/create`,
        class: "bg-h-primary-500 my-2 px-[8px] rounded flex items-center justify-center text-white font-bold w-[160px] h-[32px] box-border"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("labels.generic", {
          pt: "Criar novo tópico",
          en: "Create new topic",
        })), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.searchInput && _ctx.totalTopics! !== 1)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.totalTopics) + " " + _toDisplayString(_ctx.$t("labels.generic", {
          pt: "tópicos publicados sobre",
          en: "topics published about",
        })) + " \"" + _toDisplayString(_ctx.searchInput) + "\" " + _toDisplayString(_ctx.topicExploredMessage), 1))
          : (_ctx.searchInput)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.totalTopics) + " " + _toDisplayString(_ctx.$t("labels.generic", {
          pt: "tópico publicado sobre",
          en: "topic published about",
        })) + " \"" + _toDisplayString(_ctx.searchInput) + "\" " + _toDisplayString(_ctx.topicExploredMessage), 1))
            : (_ctx.totalTopics! !== 1)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.totalTopics) + " " + _toDisplayString(_ctx.$t("labels.generic", {
          pt: "tópicos publicados",
          en: "topics published",
        })) + " " + _toDisplayString(_ctx.topicExploredMessage), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.totalTopics) + " " + _toDisplayString(_ctx.$t("labels.generic", {
          pt: "tópico publicado",
          en: "topic published",
        })) + " " + _toDisplayString(_ctx.topicExploredMessage), 1))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", _hoisted_11, [
            _createVNode(_component_v_icon, {
              name: "md-sort",
              scale: 0.8
            }, null, 8, ["scale"]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("labels.generic", {
          pt: "Ordenar por",
          en: "Order by",
        })), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.actualOrder.label), 1),
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.actualOrder,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.actualOrder) = $event)),
              options: _ctx.ordenationMenu,
              optionLabel: "label",
              class: "!absolute top-0 opacity-0 !p-0 w-full h-full text-h-primary-500",
              panelClass: "!p-0 !py-0 !text-left [&_li]:!p-0 [&_li]:!items-left [&_ul]:!py-0 rounded w-[12rem]"
            }, {
              option: _withCtx((slotProps) => [
                _createElementVNode("button", {
                  class: _normalizeClass(["!items-left !w-full !h-full !py-1 !pl-1.5 text-xl !text-left", [{ 'p-dropdown-item p-highlight': slotProps.option.label === _ctx.actualOrder.label }]]),
                  onClick: ($event: any) => (slotProps.option.command(slotProps.option))
                }, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(slotProps.option.label), 1)
                ], 10, _hoisted_14)
              ]),
              _: 1
            }, 8, ["modelValue", "options"])
          ])
        ])
      ])
    ])
  ]))
}